module.exports = __webpack_public_path__ + "img/FlangeAdapter.53469fce.webp";